import { Badge, Box, Group, Stack, Text, Tooltip } from '@mantine/core';

import dayjs from 'dayjs';

const ActivationDateCell = ({ cell, accessorFn, format }) => {
    const { column, row } = cell;
    const rowData = row.original;

    const activatedAt = dayjs(rowData?.activatedAt);
    const expiresAt = dayjs(rowData?.expiresAt);
    const remaining = expiresAt.diff(dayjs(), 'd');
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Stack gap={0}>
                <Tooltip label={'Activated at'}>
                    <Text size={'sm'}>
                        {activatedAt ? activatedAt.format(format) : '---'}
                    </Text>
                </Tooltip>
                <Tooltip label={'Expires at'}>
                    <Group gap={4}>
                        <Text size={'sm'}>
                            {expiresAt ? expiresAt.format(format) : '---'}
                        </Text>
                        {remaining < 5 && rowData.status === 'Activated' ? (
                            <Badge
                                size={'sm'}
                                color={'red.6'}>
                                {remaining} days
                            </Badge>
                        ) : null}
                    </Group>
                </Tooltip>
            </Stack>
        </Box>
    );
};

const ActivationDateColumn = ({
    id,
    header,
    accessorFn,
    format = 'MM-DD-YYYY',
}) => ({
    id: id || header.toLowerCase(),
    accessorFn: accessorFn,
    header: header,
    size: 2,
    minSize: 160,
    Cell: ({ cell }) => (
        <ActivationDateCell
            cell={cell}
            format={format}
        />
    ),
});
export default ActivationDateColumn;
